import React, { FC, useEffect, useState } from "react"
import { View, DeviceEventEmitter, TouchableOpacity, KeyboardAvoidingView, Keyboard, VirtualizedList, useWindowDimensions, RefreshControl, ActivityIndicator } from "react-native"
import { ThemeConsumer } from "@rneui/themed"

import { config } from "../../../shared/environment"

//module
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { getAdminCustomerHistory } from "../../../redux/slices/customerSlice"
//Shared library
import { ZenBadge, ZenDivider, ZenEmptyComponent, ZenFilterModal, ZenIcon, ZenLoader, ZenSearchBar, ZenText } from "zen-core-elements"

import { filterItemsProps } from "zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal"
import { getAdminCustomerHistoryData } from "../customerHistoryModule"
import { ListToolbar } from "../../../shared/commonComponents/listToolbar"

//variable to store data limit
let limit = 10
//variable to store data total count
let total = 0
//variable to store filter payload data
let filterPayload: string | null = null

const AdminHistory: FC<{ customerId: number }> = ({ customerId }) => {
    //variable to store redux dispatch 
    const dispatch = useAppDispatch()
    const { width } = useWindowDimensions()
    //variable used to store admin Customer History data
    const { value: adminCustomerHistory, loading } = useAppSelector((state) => state?.customer?.adminCustomerHistory)
    //variable to handle list loading state
    const [listLoading, setListLoading] = useState(true)
    //variable to handle list refresh state
    const [listRefresh, setListRefresh] = useState(false)
    //Variable to control footer loader
    const [footerLoader, setFooterLoader] = useState(false)
    //variable to store offset value
    const [offset, setOffset] = useState(0)
    //variable used to handle searchBar 
    const [searchText, setSearchText] = useState<string | null>(null)
    //variable to store selected filter
    const [isVisibleFilter, setIsVisibleFilter] = useState(false)
    const [filterData, setFilterData] = useState<filterItemsProps[]>([
        {
            id: "1",
            filterName: "Custom Date",
            filterType: "dateRange",
            initialSelected: { startDate: "", endDate: "" },
            filterValue: { minDate: "", maxDate: "" }
        },
        {
            id: '2',
            filterName: 'Device Name',
            filterType: "radio",
            filterValue: [
                {
                    value: 'mobile',
                    label: 'mobile',
                },
                {
                    value: 'desktop',
                    label: 'desktop',
                }
            ],
            initialSelected: ''
        },
        {
            id: '3',
            filterName: 'Days',
            filterType: "radio",
            filterValue: [
                {
                    value: 'Today',
                    label: 'Today',
                },
                {
                    value: 'Yesterday',
                    label: 'Yesterday',
                },
                {
                    value: "This week",
                    label: "This week"
                },
                {
                    value: "This month",
                    label: "This month"
                },
            ],
            initialSelected: ''
        }
    ])
    //variable to store filter count
    const [filtercount, setFilterCount] = useState(0)

    // useEffect to trigger filterzone whenever text is searched
    useEffect(() => {
        if (searchText != null) {
            const searchDebounceFunction = setTimeout(() => {
                toggleOffsetValue()
            }, 1000)
            return () => clearTimeout(searchDebounceFunction)
        }
    }, [searchText]);

    //Method for toggle offset value
    const toggleOffsetValue = () => {
        setOffset((preset) => (preset === 0 ? -1 : 0))
    }
    //useEffect triggers whenever offset is change
    useEffect(() => {
        getAdminCustomerHistoryApi()
    }, [offset])

    //Funtion to get a admin customer history data
    const getAdminCustomerHistoryApi = async () => {
        await dispatch(getAdminCustomerHistory({ storeId: config?.storeId, customerId, data: { searchText: searchText ? searchText : "", offset: offset < 0 ? 0 : offset, limit: limit, filterData: filterPayload ? filterPayload : null } })).unwrap().then((response) => {
            if (response) {
                setListLoading(false)
                setListRefresh(false)
                setFooterLoader(false)
                total = response?.result?.userLogs?.count
            }
        }).catch((error: any) => {
            console?.log("Get admin customer history error", error)
        })
    }

    const getItem = (item: any[], index: number) => {
        let array: any = [];
        let numOfColumns = width > 600 ? 2 : 1
        for (let i = 0; i < numOfColumns; i++) {
            let temp = item?.[index * numOfColumns + i];
            temp && array?.push(temp);
        }
        return array;
    };

    const footerComponent = () => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    footerLoader ?
                        <View>
                            <ActivityIndicator size={"small"} color={theme?.primary} />
                        </View >
                        : undefined
                )}
            </ThemeConsumer>
        )
    }

    const onRefresh = () => {
        setListRefresh(true)
        filterPayload = null
        DeviceEventEmitter?.emit("clearFilter")
        setSearchText(null)
        toggleOffsetValue()
    }
    const onEndReached = () => {
        let offsetValue = offset < 0 ? 0 : offset
        if (total > offsetValue) {
            setFooterLoader(true)
            setOffset(limit + offsetValue)
        }
    }

    const renderItem = ({ item, index }: { item: getAdminCustomerHistoryData[], index: number }) => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    <View key={index} style={{ flexDirection: "row" }}>
                        {item?.map((history, ResponseDataIndex: number) => (
                            <View key={ResponseDataIndex} style={{ flex: 1 / (width > 600 ? 2 : 1) }}>
                                <View style={{
                                    marginBottom: 10,
                                    marginHorizontal: 10,
                                    padding: 10,
                                    borderRadius: 5,
                                    backgroundColor: theme.light
                                }}>
                                    <View style={{ gap: 5 }}>
                                        <View style={{ gap: 5, flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between" }}>
                                            <ZenText content={"Logged In"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                            <ZenText content={history?.loginTime} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark, top: -2 }} />
                                        </View>
                                        <View style={{ gap: 5, flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between" }}>
                                            <ZenText content={"Logged Out"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                            <ZenText content={history?.loggedOutTime} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark, top: -2 }} />
                                        </View>
                                        <ZenDivider style={{ width: "100%", height: 0.7, backgroundColor: theme?.lightGrey }} />
                                        <View style={{ gap: 5, flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between" }}>
                                            <View style={{ gap: 5 }}>
                                                <ZenText content={"Ip Address"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                                <ZenText content={history?.ipAddress} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark, top: -2 }} />
                                            </View>
                                            <View style={{ gap: 5 }}>
                                                <ZenText content={"Device"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                                <ZenText content={history?.appDeviceDetail?.deviceName} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark, top: -2 }} />
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>))}
                    </View>)}
            </ThemeConsumer>
        )
    }
    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView style={{ flex: 1, backgroundColor: "#f8f8f8", paddingBottom: 10 }}>
                    <View style={{ flex: 1 }}>
                        <ListToolbar
                            search={{
                                value: searchText ?? "",
                                onChange: (val) => { setSearchText(val as string) },
                                onCancel: () => { setSearchText(''); Keyboard?.dismiss() },
                                placeholder: 'Search by device name',
                            }}
                            filter={{
                                count: filtercount ?? 0,
                                onPress: () => setIsVisibleFilter(true),
                            }}
                        />
                        {(loading && !listRefresh && !footerLoader) ?
                            <ZenLoader lottie={require('../../../assets/infinityLoader.json')} lottieType='Local' viewStyle={{ backgroundColor: "transparent" }} /> :
                            <View style={{ flex: 1 }}>
                                <VirtualizedList
                                    keyExtractor={(_: any, index: number) => index?.toString()}
                                    getItemCount={(data: any) => data?.length}
                                    getItem={getItem}
                                    scrollEnabled={true}
                                    nestedScrollEnabled={true}
                                    renderItem={renderItem}
                                    data={adminCustomerHistory || []}
                                    keyboardDismissMode="on-drag"
                                    showsVerticalScrollIndicator={false}
                                    onEndReachedThreshold={0.01}
                                    contentContainerStyle={[{ paddingBottom: adminCustomerHistory?.length ? 10 : undefined, flex: adminCustomerHistory?.length ? undefined : 1 }]}
                                    ListFooterComponent={footerComponent}
                                    ListFooterComponentStyle={{ height: adminCustomerHistory?.length ? 70 : 0 }}
                                    ListEmptyComponent={<ZenEmptyComponent viewStyle={{ backgroundColor: theme?.light }} />}
                                    onEndReached={onEndReached}
                                    refreshControl={<RefreshControl refreshing={listRefresh} onRefresh={onRefresh} />}
                                />
                            </View>
                        }
                    </View>
                    <ZenFilterModal
                        setVisible={setIsVisibleFilter}
                        visible={isVisibleFilter}
                        filterItems={filterData}
                        setFilterItems={setFilterData}
                        title="Customer List Filter"
                        isSingleExpand={false}
                        filterCount={filtercount}
                        setFilterCount={setFilterCount}
                        onConfirm={(val) => {
                            setListLoading(true)
                            let data: { customDateRange: { begin: string | null, end: string | null }, deviceName: null | string, days?: string | null, toggleDateRange: { begin: string | null, end: string | null } | undefined } = { customDateRange: { begin: null, end: null }, deviceName: null, toggleDateRange: undefined }
                            if (val?.values?.["Device Name"]) {
                                data["deviceName"] = val?.values?.["Device Name"]
                            }
                            if (val?.values?.["Custom Date"]) {
                                data.customDateRange = { begin: val?.values?.["Custom Date"]?.startDate, end: val?.values?.["Custom Date"]?.endDate }
                            }
                            if (val?.values?.days) {
                                data.toggleDateRange = { begin: val?.values?.days?.begin, end: val?.values?.days?.end };
                            }
                            if (val?.values?.days == null) {
                                data.days = null
                            }
                            filterPayload = JSON?.stringify(data)
                            toggleOffsetValue()
                        }
                        }
                    />
                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>
    )
}

export default React.memo(AdminHistory)